import { getConfigTenant, isCorpTenant } from "@capone/common";

export const BASE_PATH_HOME = "/";

const getBasePath = () => {
  return isCorpTenant(getConfigTenant()) ? "/hotels-flights/" : "/packages/";
};

export const PATH_HOME = getBasePath();
export const PATH_HOME_SEARCH = PATH_HOME + "search/";
export const PATH_HOTELS_AVAILABILITY = PATH_HOME + "hotels-availability/";

export const PATH_REVIEW = `${PATH_HOME}review/`;
export const PATH_BOOK = `${PATH_HOME}book/`;
export const PATH_BOOK_CONFIRMATION = `${PATH_BOOK}confirm/`;

export const PATH_HOTEL_SHOP = PATH_HOME + "hotel-shop/";
export const PATH_FLIGHT_SHOP = PATH_HOME + "flight-shop/";

export const PATH_TERMS = BASE_PATH_HOME + "terms/";
